import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  display: flex;
  max-height: 3rem;
  position: relative;

  > label {
    cursor: text;
    height: 1.5rem;
    position: absolute;
    right: 1.5rem;
    top: 0.75rem;
  }
`;

export const Input = styled.input`
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xs};
  color: ${Colors.black};
  font-family: 'Roboto', sans-serif;
  font-feature-settings: 'case' on;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.03125rem;
  padding: 0.9063rem ${Spacing.Xs};
  resize: none;
  width: 100%;

  &::placeholder {
    color: ${Colors.gray[100]};
  }
`;
